let headerRoot = document.querySelector(".header-root");
let mainContent = document.querySelector(".main-content");
let annBar = document.querySelector(".ann-bar");
let desktopDropdown = document.querySelector(".desktop-nav-dropdown");

/**
 * Announcement Bar Unsticky
 */
let AnnBar = () => {
  function fixHeader() {
    headerRoot.classList.add("fixed");
    mainContent.classList.add("fixed-header");
    desktopDropdown.classList.add("fixed");
  }

  function unfixHeader() {
    headerRoot.classList.remove("fixed");
    mainContent.classList.remove("fixed-header");
    desktopDropdown.classList.remove("fixed");
  }

  // Fixed Header (Intersection Observer)
  // Note: Fixed Header Functionality relies on the announcement bar
  function fixedHeaderCallback(entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) {
        fixHeader();
      } else {
        unfixHeader();
      }
    });
  }

  let headerObserver = new IntersectionObserver(fixedHeaderCallback, {
    threshold: 0,
  });

  try {
    // Fixed Header
    // headerObserver.observe(annBar);
  } catch (e) {
    console.warn("Header Observer Error", e);
  }

  return Object.freeze({});
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    AnnBar = AnnBar();
  });
} else {
  AnnBar = AnnBar();
}


/**
 * Menu Bar Cart
 */
let MenuBar = () => {
  let cartBtns = Array.from(document.querySelectorAll(".menu-bar .cart"));

  cartBtns.forEach(btn => {
    btn.addEventListener("click", e => {
      e.preventDefault();
      Global.SideCart.show();
    });
  });

  return Object.freeze({});
}

// if (document.readyState === "loading") {
//   document.addEventListener("DOMContentLoaded", () => {
//     MenuBar = MenuBar();
//   });
// } else {
//   MenuBar = MenuBar();
// }

/**
 * Nav Bar Cart
 */
let NavBar = () => {
  let navMobileSwiper = new Swiper(".nav-bar-main.sk-mobile .swiper", {
    direction: 'horizontal',
    grabCursor: false,
    loop: false,
    freeMode: true,
    watchSlidesProgress: true,
    centeredSlides: false,
    slidesPerView: "auto",
    spaceBetween: 12,
    threshold: 5,
    focusableElements: "#sk-none",
    mousewheel: {
      forceToAxis: true,
    }
  });

  return Object.freeze({});
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    NavBar = NavBar();
  });
} else {
  NavBar = NavBar();
}
